// Performance optimization utilities for Core Web Vitals

export const optimizeImages = () => {
  // Only run on client side
  if (typeof window === 'undefined') return;
  
  // Add high priority to above-the-fold images using dataset instead of fetchpriority
  const heroImages = document.querySelectorAll('.hero-section img, .above-fold img');
  heroImages.forEach((img) => {
    if (img instanceof HTMLImageElement) {
      img.loading = 'eager';
      // Use dataset for high priority instead of fetchpriority
      img.dataset.priority = 'high';
    }
  });

  // Lazy load below-the-fold images
  const belowFoldImages = document.querySelectorAll('img:not(.hero-section img):not(.above-fold img)');
  belowFoldImages.forEach((img) => {
    if (img instanceof HTMLImageElement && !img.loading) {
      img.loading = 'lazy';
    }
  });
};

export const preloadCriticalResources = () => {
  // Only run on client side
  if (typeof window === 'undefined') return;
  
  // Preload critical images
  const criticalImages = [
    '/hero-assets/analytics-card.png',
    '/hero-assets/feedback-card.png',
    '/hero-assets/welcome-popup.png'
  ];

  criticalImages.forEach((src) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });
};

export const measurePerformance = () => {
  // Only run on client side
  if (typeof window === 'undefined' || !('PerformanceObserver' in window)) return;

  // Monitor resource loading
  try {
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.duration > 100) {
          console.warn('Slow resource:', entry.name, entry.duration + 'ms');
        }
      });
    }).observe({ entryTypes: ['resource'] });

    // Monitor long tasks
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        console.warn('Long task detected:', entry.duration + 'ms');
      });
    }).observe({ entryTypes: ['longtask'] });
  } catch (e) {
    // Silently fail if PerformanceObserver is not supported
  }
};

export const initPerformanceOptimizations = () => {
  // Only run on client side
  if (typeof window === 'undefined') return;

  // Run optimizations when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      optimizeImages();
      preloadCriticalResources();
      measurePerformance();
    });
  } else {
    // Run after a small delay to ensure DOM is ready
    setTimeout(() => {
      optimizeImages();
      preloadCriticalResources();
      measurePerformance();
    }, 100);
  }
};